import { useDispatch, useSelector } from "react-redux";
import { Accordion } from "../../../../components/Accordion";
import {
  MARKETS_VIEW,
  ODDS_FILTER_OPTIONS,
  ODDS_VIEW,
} from "../../../../constants";
import { MarketGroup } from "../MarketGroup";
import useBetSlip from "../../../../hooks/useBetSlip";
import { NameInput } from "../NameInput";

const calculateOddsCount = (minIndex, maxIndex) => {
  if (maxIndex < 0 || minIndex < 0) return 0;

  const inclusiveRangeCount = maxIndex - minIndex + 1;

  return inclusiveRangeCount;
};

export const FavView = () => {
  const dispatch = useDispatch();
  const { ppConfig } = useSelector((state) => state.filter);
  const { name = "", odds, markets } = useSelector((state) => state.favourites);
  const [, , oddsFormat] = useBetSlip();
  const { marketGroups } = ppConfig;
  const filteredMarketGroups = marketGroups.filter((group) => group.active);
  const oddsOptions = ODDS_FILTER_OPTIONS.map((option) => {
    return {
      minOdds: option.minOdds,
      maxOdds: option.maxOdds,
      label: option[oddsFormat.toLowerCase()].label,
    };
  });

  const handleNameChange = (value) => {
    dispatch({
      type: "UPDATE_FAVOURITE_NAME",
      payload: value,
    });
  };

  const minOddsIndex = oddsOptions.findIndex(
    (option) => option.minOdds >= odds.minOdds && option.minOdds <= odds.maxOdds
  );
  const maxOddsIndex = oddsOptions.findIndex(
    (option) => odds.maxOdds > option.minOdds && odds.maxOdds <= option.maxOdds
  );

  const oddsCount = calculateOddsCount(minOddsIndex, maxOddsIndex);

  const oddsDescription =
    maxOddsIndex > -1
      ? `${oddsOptions[minOddsIndex].label} - ${oddsOptions[maxOddsIndex].label}`
      : null;

  const marketsDescription = marketGroups
    .flatMap((group) => group.markets)
    .filter((market) => markets.includes(market.type))
    .map((market) => market.name)
    .join(", ");

  return (
    <>
      <NameInput name={name} handleChange={handleNameChange} />
      <Accordion title="Odds" description={oddsDescription} count={oddsCount}>
        <MarketGroup options={oddsOptions} type={ODDS_VIEW} />
      </Accordion>
      <Accordion
        title="Markets"
        description={marketsDescription}
        count={markets.length}
      >
        {filteredMarketGroups.map((group) => (
          <MarketGroup
            key={group._id}
            subHeader={group.name}
            options={group.markets}
            type={MARKETS_VIEW}
          />
        ))}
      </Accordion>
    </>
  );
};
